module.exports = __webpack_public_path__ + "img/shahr.ef7ba295.png";